import { render } from "./CRMWhatsappConversationHistoryDialog.vue?vue&type=template&id=bc43d0cc&scoped=true"
import script from "./CRMWhatsappConversationHistoryDialog.vue?vue&type=script&lang=js"
export * from "./CRMWhatsappConversationHistoryDialog.vue?vue&type=script&lang=js"

import "./CRMWhatsappConversationHistoryDialog.vue?vue&type=style&index=0&id=bc43d0cc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc43d0cc"]])

export default __exports__